// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6649bd58","455":"b9141a4e","977":"63716b52"}[chunkId] + ".chunk.js";
};